import { Component, Output, Input, EventEmitter, inject } from '@angular/core';
import { AdminService } from '../../admin.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-import-products',
  templateUrl: './import-products.component.html',
  styleUrls: ['../toolbox.component.scss'],
  imports: [MatSelectModule, MatIconModule, FormsModule, MatButtonModule],
})
export class ImportProductsComponent {
  private admnSrvc = inject(AdminService);

  @Output() toggleLoading = new EventEmitter();
  @Input() lifeProductTables;
  uploadLifeProducts = { table: null, status: null, statusClass: null };
  uploadFile;
  uploadFileName;

  onFileSelected(event) {
    this.uploadFile = event.target.files[0];
    if (this.uploadFile) {
      this.uploadFileName = this.uploadFile.name;
    }
  }

  uploadLifeProduct() {
    this.toggleLoading.emit();
    this.uploadLifeProducts.status = null;
    this.uploadLifeProducts.statusClass = null;

    this.admnSrvc
      .importLifeProducts(this.uploadLifeProducts.table, this.uploadFile)
      .subscribe({
        next: res => {
          if (res) {
            if (res.name && res.name === 'HttpErrorResponse') {
              this.toggleLoading.emit();
              this.uploadLifeProducts.status = `${res.status} - ${res.statusText} - ${res.message}`;
              this.uploadLifeProducts.statusClass = 'failure';
              return throwError(() => res.error || 'Server error');
            } else {
              this.toggleLoading.emit();
              this.uploadLifeProducts.status = res.result;
              // Will most likely need the following commented code,
              // but using a neutral color for now to display code 200's
              // so we see cases in which the data wasn't succesfully inserted into the db.
              // (ie. We get code 200's for successes of course, but as of now, we also get
              // 200's if the data is accepted but has duplicates in the db already and is NOT inserted into the table).
              // Users may think it was successful because it's green and not check their data for duplicates.

              // this.uploadLifeProducts.statusClass = 'success';
            }
          } else {
            // Empty response: still stop the loading indicator started above.
            this.toggleLoading.emit();
          }
        },
        error: catchError(err => {
          this.toggleLoading.emit();
          this.uploadLifeProducts.status = err;
          this.uploadLifeProducts.statusClass = 'failure';
          return throwError(() => err.error || 'Server error');
        }),
      });
  }
}
